/* eslint-disable */
// WARNING: Do not edit this file

const ebconfig = {
  "integration": "project-CHORES_TEST-sJTLrIILrfdiWhGEsiSp4peSM1E-9HrK",
  "version": "2020-11-20"
}

export default ebconfig;